exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload-folder-tree li{background:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/CaseFolder/Integrations/UploadFolderTree.less
// module id = 1585
// module chunks = 0